import  { useEffect, useState } from 'react';
import "../../css/bootstrap.min.css";
import "../../css/animate.min.css";
import "../../css/style.css";
import "../../css/responsive.css";
import "../../css/light-color.css";
import "../../css/floatlabel.css";
import "../../css/customstyle.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import  Header  from '../../components/sections/mainwebsite/Header';
import ScrollToTop from 'react-scroll-to-top';
import { Footer } from '../../components/sections/footer';
import { AxiosInstance } from '../../components/utils';
import MainWebFooter from '../../components/sections/mainwebsite/mainwebfooter';

function Cfp() {
      const [events, setEvents] = useState<any[]>([]);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const response = await AxiosInstance.get('/api/getevent?eventstatus=OPEN,REGISTRATIONSCLOSED,REGISTRATIONSOPEN');
        if (response.data.result === 'Success') {
          setEvents(response.data.data);
        }
      } catch (error) {
        console.error('Error fetching events:', error);
      }
    };

    fetchEvents();
  }, []);

    return (
        <>
            <div className="antialiased light-vz circle-v ">
                <Header events={events} />
                <h1 className='spacer-section'></h1>
                
                {/* Privacy Policy Section */}
                <section className="general-text">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                
                                <div className="sec-title white-heading-text text-center">
                                    <div className="d-flex justify-content-center align-items-center">
                                        <span className="icon-inner wow flipInY mr-3">
                                            <span className="fa-stack">
                                                <i className="fa rhex fa-stack-2x"></i>
                                                <i className="fa fa-file fa-stack-1x"></i>
                                            </span>
                                        </span>
                                        <h3 className="mb-0">CALL FOR PAPERS</h3>
                                    </div>
                                </div>
                                {/* MOVE BUTTON HERE (outside sec-title) */}
                                <div className="pt-4 mt-4 mb-3 bluebtn text-center">
                                    <a className="btn btn-default" href="https://forms.gle/ij6vQ4xZxhbS6LY79" target="_blank" rel="noopener noreferrer">Submit Your CFP</a>
                                </div>
                            </div>
                        </div>
                        
        <div className="row">
            <div className="col-md-12">
                <h3 className="font-600 text-black font-28 text-center importantdatestitle">IMPORTANT DATES</h3>

                <div className="border-impdate col-12 mt-5">
                    <div className="row">

                        <div className="col-md-4 col-6 right-schedule-border-impdate pl-0 pr-0">
                            <div className="toprow p-3">
                                <h5 className="font-600 font-18 text-black text-center text-uppercase">CFP <br/>Opens</h5>
                            </div>
                            <div className="lineborder-impdate">&nbsp;</div>
                            <div className="bottomrow p-3">
                                <p className="font-400 font-16 text-black text-center">27th January<br/>2026</p>
                            </div>
                        </div>

                        <div className="col-md-4 col-6 right-schedule-border-impdate pl-0 pr-0">
                            <div className="toprow p-3">
                                <h5 className="font-600 font-18 text-black text-center text-uppercase">CFP <br/>Closes</h5>
                            </div>
                            <div className="lineborder-impdate">&nbsp;</div>
                            <div className="bottomrow p-3">
                                <p className="font-400 font-16 text-black text-center">30th March<br/>2026</p>
                            </div>
                        </div>

                        <div className="col-md-4 col-6 pl-0 pr-0">
                            <div className="toprow p-3">
                                <h5 className="font-600 font-18 text-black text-center text-uppercase">Conference <br/>Date</h5>
                            </div>
                            <div className="lineborder-impdate">&nbsp;</div>
                            <div className="bottomrow p-3">
                                <p className="font-400 font-16 text-black text-center">9th July 2026</p>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <div className="row">
            <div className="col-md-12">
                <br/>
                <p className="font-16 text-para font-weight-bold">
                    Please read the entire content below before submitting your Call For Papers (CFP).
                </p>

                <h3 className="text-para mt-4">CATEGORIES, FORMATS, AND SPEAKER BENEFITS</h3>

                <p className="font-16 text-para">
                    <span className="font-400">A. New Research Category:</span><br />
                    A deep knowledge technical track that includes new research, vulnerabilities, zero days, or exploits. If your research or talk has been published/showcased (partially or entirely) before, it will fall under the current research category even though there are enhancements/changes to the original research.
                </p>

                <p className="font-16 text-para">
                    <span className="font-400">B. Current Research Category:</span><br />
                     Comprises of known security issues, new research presented/published elsewhere, case studies, twist to existing research, vulnerability, exploit, or research-in-progress.
                </p>

                <p className="font-16 text-para">
                    <span className="font-400">C. Tool Category:</span><br />
                   Comprises of open-source security tools, exploits, etc. This is an excellent opportunity for the original authors to showcase their work to the world.
                </p>
            </div>
        </div>

        <div className="row">
            <div className="col-md-12">
                <h3 className="text-para mt-4">SPEAKER BENEFITS</h3>

                <ul className="font-16 text-para">
                    <li>Complimentary Conference Only Pass (member pass)</li>
                    <li>Felicitation as Speaker – Conference Day</li>
                    <li>Special Goodie Pack</li>
                    <li>Social Media Branding</li>
                    <li>The opportunity to stand out as a subject matter expert among your peers</li>
                    <li>CPE Certificate</li>
                    <li> Speakers from outside Bangalore get a chance to claim only travel tickets (strictly journey (bus/flight) tickets post review of actual bills. Over budget bills will not be approved). This is applicable to primary speaker only.)</li>
                </ul>
            </div>
        </div>

        <div className="row">
            <div className="col-md-12">
                <h3 className="text-para mt-4">CONDITIONS</h3>
                <p className="font-16 text-para">
                   *By submitting a paper and agreeing to talk, the speakers give BSides Bangalore the right to post, publish, re-distribute online and offline, soft and/or hard copies of their presentation material including slides, source code, design specifications, detailed paper, and the recorded video of the talk.
                </p>
            </div>
        </div>

        <div className="row">
            <div className="col-md-12">
                <h3 className="text-para mt-4">SUBMISSION TOPICS</h3>
                <p className="font-400 text-para font-16 pb-2">
                    We are looking at new and cutting-edge security research that has not been published previously anywhere. Here are a few topics for your reference including (but not limited to):
                </p>

               <p className="font-400 text-para font-16 pb-2">
<span className="font-weight-bold">AI & Autonomous Security:</span> Protecting AI models and using AI for automated defense. Securing LLMs, adversarial ML defense, and AI-driven automated security operations.
</p>

<p className="font-400 text-para font-16 pb-2">
<span className="font-weight-bold">Web3.0 & Metaverse Security:</span> Decentralized identity, smart contract auditing, and virtual asset protection.
</p>

<p className="font-400 text-para font-16 pb-2">
<span className="font-weight-bold">Blockchain Security:</span> Beyond crypto—securing enterprise ledgers and private chains.
</p>

<p className="font-400 text-para font-16 pb-2">
<span className="font-weight-bold">Post-Quantum Cryptography:</span> Preparing for the quantum threat to current encryption.
</p>

<p className="font-400 text-para font-16 pb-2">
<span className="font-weight-bold">Cloud Security:</span> Architecture, serverless protection, container security (Kubernetes), and multi-cloud governance.
</p>

<p className="font-400 text-para font-16 pb-2">
<span className="font-weight-bold">IoT / ICS / SCADA:</span> Protecting critical infrastructure, industrial control systems, and manufacturing plants.
</p>

<p className="font-400 text-para font-16 pb-2">
<span className="font-weight-bold">Smart Cities:</span> Security for interconnected urban grids, 5G/6G communication, and public IoT sensors.
</p>

<p className="font-400 text-para font-16 pb-2">
<span className="font-weight-bold">DevSecOps:</span> Integrating security into CI/CD pipelines and automated compliance-as-code.
</p>

<p className="font-400 text-para font-16 pb-2">
<span className="font-weight-bold">Web App Security :</span> API security, modern web framework vulnerabilities and innovative threat modeling approaches
</p>

<p className="font-400 text-para font-16 pb-2">
<span className="font-weight-bold">Mobile Security:</span> Securing the mobile workforce and biometrics-based authentication.
</p>

<p className="font-400 text-para font-16 pb-2">
<span className="font-weight-bold">New CVE Research:</span> A platform for presenting original, previously undisclosed vulnerabilities and zero-days.
</p>

<p className="font-400 text-para font-16 pb-2">
<span className="font-weight-bold">Malware Analysis:</span> Advanced reverse engineering, behavior analysis, and anti-evasion techniques.
</p>

<p className="font-400 text-para font-16 pb-2">
<span className="font-weight-bold">Digital Forensics:</span> Cloud and memory forensics, artifact recovery, and investigative methodologies.
</p>

<p className="font-400 text-para font-16 pb-2">
<span className="font-weight-bold">New CVEs & Zero-Day Research:</span> A dedicated track for original exploits found by researchers.
</p>


            </div>
        </div>

        <div className="row">
            <div className="col-md-12">
                <h3 className="text-para mt-4">FOLLOW US:</h3>

                <p className="font-16 text-para">
                   @bsidesbangalore on <a href="https://x.com/bsidesbangalore" target="_blank">X (Twitter)</a>
                </p>
                <p className="font-16 text-para">
                   @bsidesbangalore on <a href="https://www.linkedin.com/company/bsidesbangalore/" target="_blank">LinkedIn</a>
                </p>
                <p className="font-16 text-para">
                   @bsides_bangalore on <a href="https://www.instagram.com/bsides_bangalore/" target="_blank">Instagram</a>
                </p>
                <p className="font-16 text-para">
                   @bsidesbangalore on <a href="https://youtu.be/irkzBa3OnrUe/" target="_blank">YouTube</a>
                </p>
                <p className="font-16 text-para">
                   @w3-cs on <a href="https://lnkd.in/gE5R4vgb" target="_blank">LinkedIn</a>
                </p>
                <p className="font-16 text-para">
                   @w3-cs on <a href="https://twitter.com/w3incs" target="_blank">Twitter</a>
                </p>
                <p className="font-16 text-para">
                   @w3-cs on <a href="http://instagram.com/w3incs/" target="_blank">Instagram</a>
                </p>
                <p className="font-16 text-para font-weight-bold">
                    to engage with the community & keep up to date with what's up this year.
                </p>
                <p className="font-16 text-para">
                    If you have any queries, feel free to reach us at: <span className="font-weight-bold">cfp@bsidesbangalore.in</span>
                </p>

                <p className="font-16 text-para font-weight-bold">
                   Good luck with your submission!!!
                </p>
            </div>
        </div>
        <div className="row">
            <div className="col-md-12">
                  <div className="pt-4 mt-4 mb-3 bluebtn text-center">
                     <a className="btn btn-default" href="https://forms.gle/ij6vQ4xZxhbS6LY79" >Submit Your CFP</a>
                  </div>
            </div>
            </div>
        </div>
                </section>
                
               <MainWebFooter  />
                <ScrollToTop component={<i className="fa fa-angle-up"></i>} smooth />
            </div>
        </>
    );
}

export default Cfp;
